import ArticleDetailConfiguration from './ArticleDetailConfiguration';

export default ArticleDetailConfiguration;
